import { Icon } from '@manychat/icons'

import { FlowChartBlockType } from 'common/builder/components/chart/FlowChart/types/FlowChartBlock'
import { FlowChartPlaceholderBlock } from 'common/builder/components/chart/FlowChart/types/FlowChartPlaceholderBlock'

export class FlowChartPlaceholderBlockBuilder {
  private placeholderBlock: FlowChartPlaceholderBlock

  constructor(id: string) {
    this.placeholderBlock = {
      id,
      type: FlowChartBlockType.PLACEHOLDER,
      data: {
        icon: null,
        text: '',
      },
    }
  }

  public withIcon(icon: Icon | null): FlowChartPlaceholderBlockBuilder {
    this.placeholderBlock.data.icon = icon
    return this
  }

  public withText(text: string): FlowChartPlaceholderBlockBuilder {
    this.placeholderBlock.data.text = text
    return this
  }

  public build(): FlowChartPlaceholderBlock {
    return this.placeholderBlock
  }
}
